export default "__VITE_ASSET__CPWGkHpu__"